import { Link } from "react-router-dom";
import { Home, Calculator } from "lucide-react";
import SEO from "../components/seo/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found (404) — MyFinancesGuru Tools" description="The page you're looking for could not be found." path="/404" />
      <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-28 text-center sm:px-6">
        <span className="font-heading text-7xl font-bold text-brand">404</span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-foreground">Page not found</h1>
        <p className="mt-3 text-muted-foreground">The page you're looking for doesn't exist or has moved. Try one of our free calculators instead.</p>
        <div className="mt-8 flex gap-4">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-hover"><Home className="h-4 w-4" /> Home</Link>
          <Link to="/calculators" className="inline-flex items-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-semibold transition-colors hover:border-brand hover:text-brand"><Calculator className="h-4 w-4" /> Calculators</Link>
        </div>
      </div>
    </>
  );
}
